import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import { UserEditSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import TextField from '../../Input/TextInput'

function ModalUpdateUser(props) {
  const [data, setData] = useState({
    name: '',
    username: '',
    password: ''
  })
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [loading, setLoading] = useState(false)

  const loadData = async (id) => {
    try {
      setLoading(true)
      const res = await api.get(`/users/${id}`)
      setData({
        name: res.data.data.name,
        username: res.data.data.username
      })
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (props.id !== 0) {
      loadData(props.id)
    }
  }, [props.id, props.show])

  const handleSubmit = async (values) => {
    try {
      setLoadingSubmit(true)
      const res = await api.post(`/users/${props.id}`, values)
      if (res.data.success) {
        props.onHide()
        props.refreshData()
        Common.showPopUpSuccessMessage(res.data.message)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading && (
          <Formik
            initialValues={{
              name: data.name,
              username: data.username,
              password: ''
            }}
            enableReinitialize={true}
            validationSchema={UserEditSchema}
            onSubmit={(values) => {
              handleSubmit(values)
            }}
          >
            {({
              handleBlur,
              handleSubmit,
              handleChange,
              values,
              errors,
              touched,
              isValid,
              dirty
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <TextField
                        id="name"
                        label="name"
                        name="name"
                        value={values.name}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        className="mb-1"
                        required={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TextField
                        id="username"
                        label="username"
                        name="username"
                        value={values.username}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        className="mb-1"
                        required={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TextField
                        id="password"
                        label="password"
                        name="password"
                        value={values.password}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        className="mb-1"
                        placeholder="******"
                        type="password"
                        helperText="Kosongkan jika tidak ingin mengubah password. Jika diisi: 8–20 karakter, mengandung huruf besar, huruf kecil, angka, dan simbol."
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Modal.Footer className="mt-3">
                      <CustomCloseButton onClick={props.onHide} />
                      <CustomButton
                        onClick={handleSubmit}
                        variant={
                          !isValid || !dirty || loadingSubmit
                            ? 'secondary'
                            : 'warning'
                        }
                        disabled={!isValid || !dirty || loadingSubmit}
                        text={loadingSubmit ? 'Loading...' : 'Update'}
                        classNameValue={`text-white ${
                          !isValid || !dirty || loadingSubmit
                            ? 'opacity-25'
                            : ''
                        }`}
                      />
                    </Modal.Footer>
                  </Row>
                </Form>
              )
            }}
          </Formik>
        )}
        {loading && (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-warning" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ModalUpdateUser
